import React from 'react';
import axios from 'axios';

const Badge = (props) => {
  return (
    <span className="rounded-xl bg-indigo-600 px-2 py-1 text-white text-xs mx-2 font-normal">
      Premium
    </span>
  )
}

export default Badge;
